<span class="validation-message"
  *ngIf="formControl.isInvalid">
  {{ formControl.validationErrors | bitfFormControlTranslate }}
</span>
